import { pick as _pick } from 'lodash';

import * as constants from './constants';

export const getFormType = (platformType, device, deviceType) => {
  const {
    FORM_TAB_STATES: { PLATFORM_TYPE, DEVICE, DEVICE_TYPE },
    FORM_TYPES: { DESKTOP_BROWSER, VIRTUAL_DEVICE, REAL_DEVICE, MOBILE_APP },
  } = constants;

  if (platformType === PLATFORM_TYPE.WEB && device === DEVICE.DESKTOP) {
    return DESKTOP_BROWSER;
  }

  if (platformType === PLATFORM_TYPE.WEB && device === DEVICE.MOBILE &&
    deviceType === DEVICE_TYPE.VIRTUAL) {
    return VIRTUAL_DEVICE;
  }

  if (platformType === PLATFORM_TYPE.WEB && device === DEVICE.MOBILE &&
    deviceType === DEVICE_TYPE.REAL) {
    return REAL_DEVICE;
  }

  if (platformType === PLATFORM_TYPE.MOBILE) {
    return MOBILE_APP;
  }

  return null;
};

export const getLiveTestingConfig = (formData) => {
  const { platformType, device, deviceType } = formData;
  const { FORM_TYPES: { DESKTOP_BROWSER, VIRTUAL_DEVICE, REAL_DEVICE, MOBILE_APP } } = constants;
  const formType = getFormType(platformType, device, deviceType);
  const commonValues = _pick(formData, ['assets', 'url', 'platformType', 'device']);

  if (formType === DESKTOP_BROWSER) {
    return {
      ...commonValues,
      browserConfiguration: formData.browserConfiguration,
    };
  }

  if (formType === VIRTUAL_DEVICE) {
    return {
      ...commonValues,
      deviceType: formData.deviceType,
      virtualDeviceConfiguration: formData.virtualDeviceConfiguration,
    };
  }

  if (formType === REAL_DEVICE) {
    return {
      ...commonValues,
      deviceType: formData.deviceType,
      deviceConfiguration: formData.deviceConfiguration,
    };
  }

  if (formType === MOBILE_APP) {
    return {
      ...commonValues,
      deviceConfiguration: formData.deviceConfiguration,
      mobileAppConfiguration: formData.mobileAppConfiguration,
    };
  }

  return null;
};

export const getAppTestingConfigs = (configs) => (
  configs.filter((value) => value.platformType === constants.FORM_TAB_STATES.PLATFORM_TYPE.MOBILE)
);

export const getWebTestingConfigs = (configs) => (
  configs.filter((value) => value.platformType === constants.FORM_TAB_STATES.PLATFORM_TYPE.WEB)
);

export const isTunnelStillRunning = (tunnelUnderTest, tunnels) => (
  tunnels.some((tunnel) => tunnel.getIdentifier() === tunnelUnderTest && tunnel.isRunning())
);
